<script setup>
const props = defineProps({
  progress: {
    type: Number,
    required: true
  }
})
</script>

<template>
  <div class="progress-container">
    <div class="progress" :style="{ width: progress + '%' }">
      <span class="text">{{ progress }}% Complete</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .progress-container {
    border-radius: 50px;
    max-width: 480px;
    min-height: auto;
    margin: 35px auto 15px auto;
    font-family: "Poppins", sans-serif;;
    background: #c3c3cd;
    height: 8px;
    .progress {
      position: relative;
      border-radius: 50px;
      background-image: linear-gradient(to left, #09ba52, #09ba52);
      height: 100%;
      padding-right: 6px;
      text-align: right;
      color: white;
      font-size: 12px;
      transition: 3ms all;
      padding-top: 3px;
      .text {
        min-width: 115px;
        color: #000;
        font-size: 15px;
        font-weight: 400;
        position: absolute;
        top: -25px;
        left: calc(100% - 60px);
      }
    }
  }
</style>
